import z from 'zod'

// Canadian postal code schema
export const PostalCodeSchema = z
  .string()
  .regex(
    /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/,
    'Postal code must be in Canadian format (e.g., K1A 0A6)',
  )
